module.exports = __webpack_public_path__ + "img/QUALITY.aeef95b9.png";